module.exports = "pegasus/assets/blocks/column-12-theme5.png";